<template>

  <div class="w-full h-full">
    <!--advantages-->
    <div class="max-w-[1200px] mx-auto flex justify-between mb-[10px]">
      <div v-for="adv in advantages" class="mt-[20px] text-[#223265]">
        <i class="el-icon-s-opportunity mr-[9px] inline-block"></i>
        <span>{{ adv }}</span>
      </div>
    </div>

    <BuyIspProxyView @buy-now="buyNow" class="mb-[20px] mt-0 min-h-[486px] min-w-[960px] max-w-[1200px]"></BuyIspProxyView>
    <PaymentView v-if="showPaymentView" @close="handleClosePaymentView" ref="paymentView"></PaymentView>
  </div>
</template>

<script>
import BuyIspProxyView from "@/components/buy-isp-proxy-view.vue"
import PaymentView from "@/views/payment/payment-view.vue"

export default {
  name: 'staticisp',
  components: {
    BuyIspProxyView,
    PaymentView,
  },

  data() {
    return {
      Loading: false,
      showPaymentView: false,
    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    
    advantages() {
      return this.$t('buy_isp_proxy.advantages')
    },

    isLogin() {
      return this.$store.state.isLogin
    },
  },

  created() {
    this.updateCurrentMenuUrl('/ucenter/staticisp/');
  },
  methods: {
    
    buyNow: function (item) {
      let that = this;
      if (that.isLogin) {
        item.source = '/ucenter/staticisp'
        
        that.showPaymentView = true;
        that.$nextTick(() => {
          if (that.$refs.paymentView) {
            that.$refs.paymentView.updateInfo(item)
          }
        })
        // this.$router.push({ path: '/payment', query: item })
      } else {
        this.$router.push({path:'/login', query: {redirect: this.$route.fullPath}})
      }
    },

    handleClosePaymentView() {
      this.showPaymentView = false;
    },
  }
}

</script>

<style lang="scss" scoped>
::v-deep {
  .el-loading-mask {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-loading-spinner {
    margin: 0;
    width: fit-content;
  }
  
  .el-collapse {
    width: 100%;
    border-top: none;
    border-bottom: none;
  }

  .el-collapse-item__header {
    width: 100%;
    border-bottom: none;
  }

  .el-collapse-item__wrap {
    border-bottom: none;
  }

  .el-collapse-item.is-active .el-collapse-item__header .el-icon-caret-right {
    display: none;
  }
  .el-collapse-item.is-active .el-collapse-item__header .el-icon-caret-bottom {
    display: inline-block;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .proxy-time, .proxy-skus, .proxy-summary {
    border: 1px solid #d5ddf9;
    box-shadow: none;
  }

  .static-isp-checkout-btn,
  .static-isp-checkout-btn:hover {
    color: #fff !important;
  }
}

</style>
